import React from 'react';
import { TableCell, Box } from '@mui/material';
import {
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
} from '@mui/icons-material';
import type { SortOrder } from '@/types/pagination';

interface SortableTableCellProps<T extends string = string> {
  label: string;
  sortKey: T;
  currentSortBy: string;
  currentSortOrder: SortOrder;
  onSort: (sortKey: T) => void;
  align?: 'left' | 'center' | 'right';
}

export const SortableTableCell = <T extends string = string>({
  label,
  sortKey,
  currentSortBy,
  currentSortOrder,
  onSort,
  align = 'left',
}: SortableTableCellProps<T>): React.ReactElement => {
  const isActive = currentSortBy === sortKey;

  return (
    <TableCell align={align}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          userSelect: 'none',
          justifyContent:
            align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start',
        }}
        onClick={() => onSort(sortKey)}
      >
        {label}
        {isActive &&
          (currentSortOrder === 'asc' ? (
            <ArrowUpwardIcon fontSize="small" sx={{ ml: 0.5 }} />
          ) : (
            <ArrowDownwardIcon fontSize="small" sx={{ ml: 0.5 }} />
          ))}
      </Box>
    </TableCell>
  );
};
